export default "/images/framework/WordHistoryEng.6d9db214.svg?6d9db214";